export const REFRESH_INTERVALS = [0, 5, 10, 15, 30, 60] as const;
const STORAGE_KEY = "tradingbridge.refresh-seconds.v1";

export function loadRefreshSeconds(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const value = stored === null ? 10 : Number(stored);
    return REFRESH_INTERVALS.some((interval) => interval === value) ? value : 10;
  } catch { return 10; }
}

export function saveRefreshSeconds(value: number): void {
  if (!REFRESH_INTERVALS.some((interval) => interval === value)) throw new Error("無效的刷新間隔。");
  localStorage.setItem(STORAGE_KEY, String(value));
}

/** Schedule from completion, never accumulate requests after a slow response. */
export class AutoRefresh {
  private timer: ReturnType<typeof setTimeout> | undefined;
  private running = false;
  private seconds = 0;

  constructor(private readonly allowed: () => boolean, private readonly refresh: () => Promise<void>) {}

  configure(seconds: number): void {
    this.seconds = seconds;
    this.schedule();
  }

  wake(): void {
    if (this.timer !== undefined) clearTimeout(this.timer);
    this.timer = undefined;
    void this.tick();
  }

  private schedule(): void {
    if (this.timer !== undefined) clearTimeout(this.timer);
    this.timer = undefined;
    if (this.seconds > 0 && !this.running) this.timer = setTimeout(() => void this.tick(), this.seconds * 1000);
  }

  private async tick(): Promise<void> {
    if (this.running || this.seconds === 0) return;
    this.running = true;
    try {
      if (this.allowed()) await this.refresh();
    } catch {
      // Refresh owns the visible error state; keep scheduling after failures.
    } finally {
      this.running = false;
      this.schedule();
    }
  }
}
